<template>
    <canvas ref="myChart" height="80"></canvas>
</template>

<script>
import { bytesToGB } from '@/utils'
import {
    Chart,
    ArcElement,
    LineElement,
    BarElement,
    PointElement,
    BarController,
    BubbleController,
    DoughnutController,
    LineController,
    PieController,
    PolarAreaController,
    RadarController,
    ScatterController,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    RadialLinearScale,
    TimeScale,
    TimeSeriesScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip,
    SubTitle
} from 'chart.js'

export default {
    name: 'FileQuotaUsageChart',
    props: {
        chartData: Object
    },
    data() {
        return {
            barChart: null
        }
    },
    watch: {
        chartData() {
            this.barChart.data = this.chartData
            this.barChart.update()
        }
    },
    mounted() {
        Chart.register(
            ArcElement,
            LineElement,
            BarElement,
            PointElement,
            BarController,
            BubbleController,
            DoughnutController,
            LineController,
            PieController,
            PolarAreaController,
            RadarController,
            ScatterController,
            CategoryScale,
            LinearScale,
            LogarithmicScale,
            RadialLinearScale,
            TimeScale,
            TimeSeriesScale,
            Decimation,
            Filler,
            Legend,
            Title,
            Tooltip,
            SubTitle
        )

        const maxByte = this.chartData.datasets.reduce((sum, dataset) => sum + (dataset.data[0] || 0), 0)

        this.barChart = new Chart(this.$refs.myChart, {
            type: 'bar',
            data: this.chartData,
            options: {
                maintainAspectRatio: false,
                responsive: true,
                indexAxis: 'y',
                interaction: {
                    mode: null
                },

                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        onClick: null,
                        labels: {
                            usePointStyle: true,
                            pointStyle: 'circle',
                            generateLabels: chart => {
                                const datasets = chart.data.datasets
                                return datasets.map((dataset, i) => ({
                                    text: `${dataset.label} (${bytesToGB(dataset.data[0])} GB)`,
                                    fillStyle: dataset.backgroundColor,
                                    hidden: !chart.isDatasetVisible(i),
                                    lineCap: 'round',
                                    lineDash: [],
                                    lineDashOffset: 0,
                                    lineJoin: 'round',
                                    lineWidth: 0,
                                    strokeStyle: dataset.backgroundColor,
                                    pointStyle: 'circle',
                                    datasetIndex: i
                                }))
                            }
                        }
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                scales: {
                    x: {
                        display: false,
                        stacked: true,
                        max: maxByte
                    },
                    y: {
                        display: false,
                        stacked: true
                    }
                }
            }
        })
    }
}
</script>
